import type React from "react"
import type { ReviewResponse } from "@/types/review"
import { Avatar } from "@/components/ui"
import { Star } from "lucide-react"
import { format } from "date-fns"
import { useAppDispatch, useAppSelector } from "@/app/hooks"
import { selectCurrentUser } from "@/features/auth/authSlice"
import { deleteReview } from "@/features/siteReviews/siteReviewsSlice"
import "./ReviewItem.css"

type ReviewItemProps = {
  review: ReviewResponse
  onEdit: (review: ReviewResponse) => void
}

export const ReviewItem: React.FC<ReviewItemProps> = ({ review, onEdit }) => {
  const dispatch = useAppDispatch()
  const currentUser = useAppSelector(selectCurrentUser)
  const formattedDate = format(new Date(review.createdAt), "yyyy.MM.dd")

  // Check if current user is the author of the review
  const isAuthor = currentUser && String(currentUser.id) === String(review.author.id)

  const handleDelete = () => {
    if (window.confirm("정말로 이 리뷰를 삭제하시겠습니까?")) {
      void dispatch(deleteReview(review.id))
    }
  }

  return (
    <div className="review-item">
      <div className="review-header">
        <div className="review-author">
          <Avatar 
            src={review.author.profileImageUrl} 
            alt={review.author.nickname} 
            size="sm" 
          />
          <div className="author-info">
            <span className="author-name">{review.author.nickname}</span>
            <div className="review-meta">
              <div className="rating-stars">
                {Array.from({ length: 5 }).map((_, i) => (
                  <Star 
                    key={i.toString()} 
                    size={12} 
                    fill={i < review.rating ? "currentColor" : "none"} 
                    strokeWidth={i < review.rating ? 0 : 1.5}
                  />
                ))}
              </div>
              <span>•</span>
              <span>{formattedDate}</span>
            </div>
          </div>
        </div>

        {isAuthor && (
          <div className="review-item-actions">
            <button 
              type="button" 
              className="review-item-btn edit" 
              onClick={() => { onEdit(review); }}
            >
              수정
            </button>
            <button 
              type="button" 
              className="review-item-btn delete" 
              onClick={handleDelete}
            >
              삭제
            </button>
          </div>
        )}
      </div>

      <div className="review-content">{review.comment}</div>
      
      {/* TODO: API에 이미지 필드 추가 시 연동 */}
      {/* 
      <div className="review-footer">
        <button className="review-action">
          <ThumbsUp size={14} />
          <span>도움이 돼요</span>
        </button>
      </div>
      */}
    </div>
  )
}